import { styled, Dialog } from '@mui/material';

export const ModalSheetDialog = styled(Dialog)(({ theme }) => ({
  padding: theme.spacing(2, 0),
  '& .MuiDialog-paper': {
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    margin: 0,
    width: '100%',
    position: 'absolute',
    top: 0,
    display: 'flex',
    flexDirection: 'column'
  },
  '& .MuiDialogContent-root': {
    overflowY: 'auto',
    flex: 1
  }
}));
